import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { isEmpty, set } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import cellEditFactory from "react-bootstrap-table2-editor"
import * as Yup from "yup"
import { useFormik } from "formik"

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Table,
  CardTitle,
  InputGroup,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import {
  getReports as onGetReports,
  addNewVector as onAddNewVector,
  updateVector as onUpdateVector,
  deleteVector as onDeleteVector,
  getAuthUsers as onGetAuthUser,
  getReportsSuccess as onGetReportsSuccess,
} from "store/actions"

// import ReportsModal from "./ReportsModal"
import Columns from "./Columns"
// import { expandRow } from "./CustomerDetails"
// import OffCanvasModel from "components/OrdersOffCanvas/offCanvas"
import Filter from "components/Common/filterComponentForCustomers"
import FilterComponent from "components/Common/filterComponentForCustomers"

const Reports = props => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [reportList, setVectorList] = useState([])
  const [report, setVector] = useState(null)

  const [path, setPath] = useState(location)
  const paginate = { size: 50, page: 1 }

  useEffect(() => {
    setPath(location.pathname)
    if (reports.hasOwnProperty("docs")) {
      dispatch(onGetReportsSuccess([{}]));
    }
  }, [location])

  const { reports, designerUsers } = useSelector(state => ({
    reports: state.Reports.reports,
    designerUsers: state.Reports.auth,
  }))

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
  }

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isRight, setIsRight] = useState(false)
  const [designers, setDesigners] = useState({})
  const [jsonFilter, setJsonFilter] = useState({})
  const [filter, setFilter] = useState({})
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: 50,
    custom: true,
  })

  const handleTableChange = (type, { page, sizePerPage }) => {
    const json = filterFunction(page)
    
    const queryString = new URLSearchParams({
      ...json.params,
      ...json.paginate,
    }).toString()
    window.history.pushState({}, "", `${path}?${queryString}`)
    dispatch(onGetReports(json))
  }

  const handleFilterClick = (filter) => {
    const { colorStatus, designer, email, paymentStatus, orderDate, sales } = filter
    
    let json = {
      params: {},
      paginate: { size: 50, page: 1 },
    }

    designer.value ? (json.params.assTo = designer.value) : ""
    paymentStatus.value !== "" ? (json.params.paymentStatus = paymentStatus.value) : ""
    sales.value !== "" ? (json.params.assToSalesMan = sales.value) : ""
    email ? (json.params.userEmail = email) : ""
    orderDate.length > 0 ? (json.params.submitDateTime = { $gte: orderDate[0], $lte: orderDate[1] }) : ""
    setJsonFilter(json)
    dispatch(onGetReports(json))
  }

  const toggleViewModal = () => setModal1(!modal1)

  const toLowerCase1 = str => {
    return str === "" || str === undefined ? "" : str.toLowerCase()
  }

  useEffect(() => {
    if (!reports.hasOwnProperty("docs")) {
      let json = {
        params: {},
        paginate: { size: 50, page: 1 },
      }
      dispatch(onGetReports(json))
    }
  }, [dispatch, reports])

  useEffect(() => {
    if (!designerUsers.hasOwnProperty("docs")) {
      dispatch(onGetAuthUser())
    }
    setDesigners(designerUsers)
  }, [dispatch, designerUsers])

  useEffect(() => {
    setVectorList(reports)
    setPageOptions({
      sizePerPage: reports.limit,
      page: reports.offset,
      totalSize: reports.totalDocs,
      custom: true,
    })
  }, [reports])

  useEffect(() => {
    if (!isEmpty(reports) && !isEdit) {
      setVectorList(reports)
      setIsEdit(false)
    }
  }, [reports])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setVector(null)
    } else {
      setModal(true)
    }
  }

  const handleVectorClick = arg => {
    const report = arg

    setVector({
      id: report.id,
      reportId: report.reportId,
      billingName: report.billingName,
      reportdate: report.reportdate,
      total: report.total,
      paymentStatus: report.paymentStatus,
      paymentMethod: report.paymentMethod,
      badgeclass: report.badgeclass,
    })

    setIsEdit(true)

    toggle()
  }

  var node = useRef()

  const onClickDelete = report => {

    dispatch(onDeleteVector(report._id))
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const handleChange = (oldValue, newValue, row, column, done) => {
    if (column.dataField === "assTo") {
      dispatch(onUpdateVector(row))
    } else {
      dispatch(onUpdateVector(row))
    }
  }

  function filterFunction(page) {
    const queryParams = new URLSearchParams(location.search)
    // const params = { designation: "User", ...filter }
    const params = jsonFilter.hasOwnProperty("params") ? jsonFilter.params : {}
    // for (let [key, value] of queryParams.entries()) {
    //   params[key] = value
    // }

    // params.page = params.page > 1 ? params.page : page
    // delete params.size
    

    let json = { params, paginate: { size: paginate.size, page: page } }
    return json
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Report</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Reports" breadcrumbItem="Reports" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="_id"
                    columns={Columns(
                      toggle,
                      handleValidDate,
                      handleVectorClick,
                      onClickDelete,
                      toLowerCase1,
                      toggleViewModal,
                      designers,
                      path
                    )}
                    data={
                      reports.hasOwnProperty("docs") ? reports.docs : reports
                    }
                  // cellEdit={ cellEditFactory({ mode: 'click' }) }
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={
                          reports.hasOwnProperty("docs")
                            ? reports.docs
                            : reports
                        }
                        columns={Columns(
                          toggle,
                          handleValidDate,
                          handleVectorClick,
                          onClickDelete,
                          toLowerCase1,
                          toggleViewModal,
                          designers,
                          path
                        )}
                        bootstrap4
                        search
                      // cellEdit={ cellEditFactory({ mode: 'click' }) }
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row>
                              <Col sm="9">
                                <FilterComponent
                                  handleFilterClick={handleFilterClick}
                                  designers={designers}
                                />
                              </Col>
                              <Col sm="3">
                                <CardBody>
                                  <div>
                                    <Row>
                                      <Col sm="6">
                                        <div>
                                          <p className="text-muted mb-2">
                                            Paid
                                          </p>
                                          {/* <p>{reports.hasOwnProperty("docs") ? reports.paymentStatus.totalPaid : 0}</p> */}
                                          <h5>$ {reports.hasOwnProperty("docs") ? reports.paymentStatus.totalPaid.toLocaleString("en-US") : 0}</h5>
                                        </div>
                                      </Col>
                                      <Col sm="6">
                                        <div className="text-sm-end mt-4 mt-sm-0">
                                          <p className="text-muted mb-2">
                                            Payable
                                          </p>
                                          <h5>
                                            $ {reports.hasOwnProperty("docs") ? reports.paymentStatus.totalDue.toLocaleString("en-US") : 0}
                                            {/* <span className="badge bg-success ms-1 align-bottom">
                                              + 1.3 %
                                            </span> */}
                                          </h5>
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                </CardBody>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={{
                                      filter: true,
                                      pagination: true,
                                      sort: false,
                                      cellEdit: false,
                                    }}
                                    keyField="_id"
                                    responsive
                                    breported={true}
                                    striped={false}
                                    // defaultSorted={defaultSorted}
                                    // selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    onTableChange={handleTableChange}
                                    cellEdit={cellEditFactory({
                                      mode: "dbclick",
                                      blurToSave: true,
                                      afterSaveCell: handleChange,
                                    })}
                                    // expandRow={expandRow}
                                    ref={node}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Reports.propTypes = {
  reports: PropTypes.array,
  onGetReports: PropTypes.func,
  onAddNewVector: PropTypes.func,
  onDeleteVector: PropTypes.func,
  onUpdateVector: PropTypes.func,
}

export default withRouter(Reports)
